import React from "react";
import clsx from "clsx";
import { Col } from "react-bootstrap";

import styles from "./layout.module.scss";

type FormColumnProps = {
	children?: React.ReactNode;
	className?: string;
};

export const FormColumn = ({ children, className }: FormColumnProps) => {
	return <Col className={clsx(styles.formColumn, className)}>{children}</Col>;
};
